export default __webpack_public_path__ + "static/media/Quote_White.05b2bec0.svg";